export enum MediaQueriesEnum {
  isMobile = '(max-width: 767px)',
  isTablet = '(max-width: 991px)',
  isDesktop = '(min-width: 992px)',
}
